module.exports = __webpack_public_path__ + "img/chainE01.a02939d2.png";